import React, { createContext } from 'react';

const Context = createContext({});

const Props = ({ children, ...props }: any): React.ReactElement => <Context.Provider value={props}>{children}</Context.Provider>;

Props.Context = Context;
export default Props;
